<template>
  <v-dialog
    v-model="dialog"
    max-width="400"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title class="headline justify-space-between">
        {{ $t("pax_supplements") }}
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div
          v-if="
            hotel_to_edit &&
              hotel_to_edit.settings &&
              hotel_to_edit.settings.pax_supplements
          "
        >
          <v-row>
            <v-col
              v-for="(value, key) in hotel_to_edit.settings.pax_supplements"
              :key="key"
              cols="12"
            >
              <v-text-field
                v-model="hotel_to_edit.settings.pax_supplements[key]"
                @input="value"
                :label="$t('pax_supplement_for', { number: parseInt(key) })"
                :rules="rules_pax_supplements"
                append-icon="mdi-percent-outline"
                type="number"
                outlined
                rounded
                dense
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <div v-else class="d-flex justify-center pa-4">
          <v-progress-circular
            indeterminate
            color="secondary"
          ></v-progress-circular>
        </div>
      </v-card-text>
      <v-card-actions class="pt-0 pb-5 justify-center">
        <v-btn
          color="secondary"
          rounded
          class="pl-5 pr-5"
          @click="updateHotel"
          :disabled="!hotel_to_edit"
        >
          {{ $t("save") }}
        </v-btn>
        <v-btn text rounded depressed class="pl-5 pr-5" @click="dialog = false">
          {{ $t("cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as Utils from "@/utils.js";
import { mapGetters, mapState } from "vuex";

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    hotel_to_edit: null
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    rules_pax_supplements() {
      // Permitimos solor numero entero
      return [v => (v && v % 1 === 0) || this.$t("number_must_be_integer")];
    },
    ...mapState({
      hotels: state => state.hotel.all_hotels,
      snackbar: state => state.snackbar
    }),
    ...mapGetters(["current_hotel"])
  },
  methods: {
    updateHotel: function() {
      this.$store.dispatch("setSnackbar", {
        title: this.$t("modifying_hotel"),
        color: "secondary"
      });
      this.$store
        .dispatch("updateHotel", this.hotel_to_edit)
        .then(() => {
          //Save modifications
          this.$store.dispatch("setSnackbar", {
            title: this.$t("modified_hotel"),
            text: this.$t("modified_hotel_ok", {
              name: this.hotel_to_edit.name
            }),
            color: "accent"
          });
          this.dialog = false;
        })
        .catch(() => {
          this.$store.dispatch("setSnackbar", {
            title: this.$t("something_went_wrong"),
            color: "error"
          });
        });
    }
  },
  mounted() {
    this.$store
      .dispatch("fetchAllHotels")
      .then(() => {
        this.hotel_to_edit = this.hotels.find(
          h => parseInt(h.id) === parseInt(this.current_hotel.id)
        );
      })
      .catch(() => {
        Utils.showError(this, "something_went_wrong");
      });
  }
};
</script>
